import React, { Component } from 'react';

import './Chances.css';

export default class Chances extends Component {
   renderPlaceholder(width) {
      return <span className="placeholder" style={{ width: `${width}px` }}></span>;
   }

   renderChancesList(chances, key, title, suggested = false, example = false) {
      if (!chances || !Array.isArray(chances)) return null;
      
      const items = chances.map((item, index) => {
         const advanced = item.competition && item.competition.every(child => child.weight >= 0);
         
         return (
            <details key={`${key}-${index}`}>
               <summary>
                  <strong>
                     <em style={{ transform: `scaleX(${item.chance})`, transformOrigin: 'center left' }}></em>
                     {parseInt(item.chance * 100)}%
                  </strong>
                  {suggested && (
                     <strong className="suggested">
                        <em style={{ transform: `scaleX(${item.chanceBonus3})`, transformOrigin: 'center left' }}></em>
                        {parseInt(item.chanceBonus3 * 100)} / {parseInt(item.chanceBonus2 * 100)} / {parseInt(item.chanceBonus1 * 100)}%
                     </strong>
                  )}
                  {example ? (
                     <>
                        <b>{this.renderPlaceholder(20)}</b>
                        <i>{this.renderPlaceholder(40)}</i>
                        <span>{this.renderPlaceholder(Math.random() * 100 + 150)}</span>
                     </>
                  ) : (
                     <>
                        <b>{item.vacancies}</b>
                        <i>{item.score} ({item.bonus})</i>
                        <span>{item.name} - {item.list}</span>
                     </>
                  )}
               </summary>
               {!example && (
                  <>
                     <small>
                        <strong>Ред</strong>
                        <b>Име</b>
                        <b>Номер</b>
                        <i>Точки</i>
                        {advanced && <i>Тежест</i>}
                        {advanced && <span>Сигурен прием</span>}
                     </small>
                     <ol>
                        {item.competition && item.competition.map((child, index) => (
                           <li className={child.certain && 'certain'} key={`${key}-${index}`}>
                              <p>
                                 <b>{child.name}</b>
                                 <b>{child.id}</b>
                                 <i>{child.score} ({child.bonus})</i>
                                 {advanced && <i>{parseInt(child.weight * 100)}%</i>}
                                 {advanced && <span>{child.certain || '-'}</span>}
                              </p>
                           </li>
                        ))}
                     </ol>
                  </>
               )}
            </details>
         );
      });

      return items.length ? (
         <section className={example ? "example" : ""}>
            <h3>
               {title}
            </h3>
            <small>
               <strong>Шанс</strong>
               {suggested && (<strong className="suggested">Желание 1 / 2 / 3</strong>)}
               <b>Места</b>
               <i>Точки</i>
               <span>Детска градина</span>
            </small>
            <div>
               {items}
               {example && suggested && (
                  <button onClick={() => window.location.hash = `${this.props.pages.subscriptionPremium}`}>
                     Отключи с Премиум план
                  </button>
               )}
            </div>
         </section>
      ) : null;
   }

   render() {
      const { chances, suggested, timestamp, subscription } = this.props;
      const example = suggested && subscription !== 'premium';
      const showSuggested = chances && chances.length > 2;
      
      return (
         <div className='Chances'>
            {this.renderChancesList(chances, `${timestamp}-chances`, 'Текущи шансове')}
            {suggested && showSuggested && this.renderChancesList(suggested, `${timestamp}-suggested`, 'Препоръчано подреждане', true, example)}
         </div>
      );
   }
}